module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAUlJREFUOE+9lLFKA0EQhmduuaRVFJvo2Yh3CQg+grWdL2DlA2hlYSE+gSK2ltY+gWhrJyiaWN6phSixEfWW3V9GOEjkkt3kxKu2+Oe7f3b+WW5HNdCYH4CbZqaXesu5CpAJb3GqJ/8PmKQ5+3RfdOV0+OdAa7Dl4zBQvC86p0MfWN8AXEMRh0rRrhQZQ3tyBvHEoB+5HTJfMOyyAMDBlZxLgYAl5k8m5JViwwRriE5aqV4f6HqUYAO0o6DOjDKnAWhGoJbpWRm1tvjwcfkzKF8gwPfN7CvuROELiKd+Dec1TvX0SEAGjljxu7W0XdoucJxkesPboUa+UAvqhwBWZQE6UdjtGxjoKcnyhjdQIO35+jkBK2XAIkJjAYu89jqsBCy7Q2+gCGVrWo/64LYRbg5bT9Hw3Vx4HTDNDhPKNrhgRb3X+ydi37x+A1IU33aJyTqLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/merchant_red.png
// module id = 36vG
// module chunks = 2